import React from "react";

export default function AssetDigitalTwinCard()
{
   

    return (

		<div
		           style={{
		               width: "100%",
		                background: "#111820",
		               border: "1px solid #e3e9f0",
		               borderRadius: "14px",
		               overflow: "hidden",
		               boxShadow: "0 10px 24px rgba(0,0,0,.08)",
					   position: "relative"
		           }}
		       >

           

          

                {/* Top Overlay */}

                <div
                    style={{
                        left: 0,
                        right: 0,
                        top: 0,
                        height: "50px",
                        background: "rgba(15,20,28,.82)",
                        backdropFilter: "blur(8px)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 18px",
                        zIndex: 20,
						borderTopLeftRadius:'14px',
						borderTopRightRadius:'14px',
						
                    }}
                >

                    <div
                        style={{
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: "bold",
                            letterSpacing: ".8px",
                            textTransform: "uppercase"
                        }}
                    >
                        Giraffe Digital Twin
                    </div>

                    <div
                        style={{
                            color: "#8fc5ff",
                            fontWeight: "bold",
                            fontSize: "12px"
                        }}
                    >
                        X: 482&nbsp;&nbsp;Y: 196
                    </div>

                </div>

                <iframe
                    title="Giraffe Asset Position"
                    src="https://tour.giraffe360.com/49c74ed43a75417c96cf6a2684fac357"
                    style={{
                        width: "100%",
                        height: "400px",
                        border: "none",
                        display: "block"
                    }}
                />

                {/* Floating Action Button */}

                <button
                    style={{
                        position: "absolute",
                        right: "22px",
                        bottom: "22px",
						background: "rgba(90,155,214,.88)",
						backdropFilter: "blur(12px)",
						border: "1px solid rgba(255,255,255,.25)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "999px",
                        padding: "14px 22px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 10px 30px rgba(0,0,0,.35)",
                        transition: ".2s",
                        zIndex: 20
                    }}
                >
                    📍 Move Asset
                </button>

            </div>


    );
}